import { Compass, DollarSign, Film, KeyRound, Layers, ListVideo, Radar, Target, type LucideIcon } from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  group: 'Library' | 'Audiences' | 'Activation' | 'Account';
  keywords?: string[];
}

/** Sidebar entries (relative to the module base path). */
export const SCENEWISE_NAV: NavItem[] = [
  { path: '/sources', label: 'Sources', icon: ListVideo, group: 'Library', keywords: ['youtube', 'feed', 'channel', 'import'] },
  { path: '/videos', label: 'Videos', icon: Film, group: 'Library', keywords: ['analysis', 'moments'] },
  { path: '/explore', label: 'Explore', icon: Compass, group: 'Audiences', keywords: ['search', 'semantic', 'moments'] },
  { path: '/segments', label: 'Segments', icon: Target, group: 'Audiences', keywords: ['rules', 'export', 'dv360', 'webhook'] },
  { path: '/overlay', label: 'Overlay', icon: Layers, group: 'Activation', keywords: ['publishers', 'creatives', 'campaigns', 'sdk'] },
  { path: '/discovery', label: 'Publisher discovery', icon: Radar, group: 'Activation', keywords: ['sincera', 'prospects', 'video player', 'sites'] },
  { path: '/costs', label: 'Costs', icon: DollarSign, group: 'Account', keywords: ['usage', 'spend', 'gemini'] },
  { path: '/api-keys', label: 'API keys', icon: KeyRound, group: 'Account', keywords: ['token', 'integration'] },
];

/** @deprecated use SCENEWISE_NAV */
export const MOMENT_NAV = SCENEWISE_NAV;
